<template>
  <div>
    <s-pageheader title="工资管理" />
    <ak-model-filter-card model="salary" @search="search" @reset="reset" />
    <!-- <ak-model-count-group :options="options" /> -->
    <div class="text-center list">
      <ak-model-count
        class="m-b-20"
        model="salary"
        icon="dollar"
        sum="orderSalaryP"
        note="订单工资P统计"
        :where="where"
        :format="(val) => { return `${val || 0} 元`}"
        :style="setStyle"
      />
      <ak-model-count
        class="m-b-20"
        model="salary"
        icon="dollar"
        sum="orderSalaryT"
        note="订单工资T统计"
        :where="where"
        :format="(val) => { return `${val || 0} 元`}"
        :style="setStyle"
      />
      <ak-model-count
        class="m-b-20"
        model="salary"
        icon="dollar"
        sum="realSalary"
        note="实际工资统计"
        :where="where"
        :format="(val) => { return `${val || 0} 元`}"
        :style="setStyle"
      />
      <ak-model-count
        class="m-b-20"
        model="salary"
        icon="dollar"
        sum="realProfit"
        note="实际利润统计"
        :where="where"
        :format="(val) => { return `${val || 0} 元`}"
        :style="setStyle"
      />
      <ak-model-count
        class="m-b-20"
        model="salary"
        icon="dollar"
        sum="totalPrice"
        note="销售额统计"
        :where="where"
        :format="(val) => { return `${val || 0} 元`}"
        :style="setStyle"
      />
    </div>
    <ak-model-card model="salary" :perPage="30" :page.sync="page" :filters="filters" />
  </div>
</template>

<script>
import Bus from '@/assets/js/eventBus'
import PageHeader from '@/components/PageHeader/PageHeader'
export default {
  components: {
    's-pageheader': PageHeader,
  },
  data () {
    return {
      where: {},
      filters: {},
      page: 1,
      width: document.body.clientWidth
    }
  },
  mounted () {
    const that = this
    window.addEventListener('resize', () => {
      that.width = document.body.clientWidth
    })
  },
  computed: {
    setStyle () {
      if (this.width >= 1400) {
        return {
          width: '19% !important'
        }
      }
      if (this.width >= 800) {
        return {
          width: '45% !important'
        }
      }
      return {
        width: '100% !important'
      }
    }

  },
  methods: {
    search (filters) {
      this.where = filters
      // filters是组件自动生成的where搜索参数
      this.page = 1
      this.filters = filters // 修改modelTable的查询条件会自动触发刷新
    },
    reset () {
      this.where = {}
      this.page = 1
      this.filters = {}
      Bus.$emit('reset', [])
      Bus.$emit('resetSalary', '')
    }
  }
}
</script>

<style>
.Statistics{
  text-align: center;
}
.list{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}
</style>
